import moment from "moment";
import ApiService from "../services/ApiService";
interface ProductionPeeling {
  id: number;
  qty: string;
  reQty: string;
  waste: string;
  status: string;
  dateIn: Date;
  dateOut: Date;
  remark: string;
  production_id: string;
  production_data: any;
  design_material_item_id: string;
  design_material_item_data: any;
  created_by: string;
}
const CancelToken = ApiService.getInstance().CancelToken;
let cancelRequest;
const ProductionPeelings: Array<ProductionPeeling> = [];

const deleteProductionPeeling = function (item: ProductionPeeling) {
  return ApiService.delete(`production-peeling/${item.id}/`);
};

const addProductionPeeling = function (item, id) {
  const formData = new FormData();
  delete item.created_by
  const dateFieldKey: any = [
    "dueDate",
    "dateIn",
    "dateOut",
    "peelingDateIn",
    "peelingDateOut",
    "peelingDateIn",
    "peelingDateOut",
    "fusingDateIn",
    "fusingDateOut",
  ];
  for (const key in item) {
    if (dateFieldKey.includes(key)) {
      formData.append(key, moment(item[key]).format("YYYY-MM-DD"));
    } else {
      formData.append(key, item[key]);
    }
  }
  if (id) {
    return ApiService.put(`production-peeling/${id}/`, formData);
  } else {
    return ApiService.post("production-peeling/", formData);
  }
};

const exportProductionPeelingData = function (ids) {
  return new Promise((res, rej) => {
    ApiService.csvFile(
      "export/production-peeling/?productionPeeling_id=" + ids,
      "productionPeeling-data"
    ).then((data) => res(data));
  });
};
const exportPDFProductionPeelings = function (ids) {
  return new Promise((res, rej) => {
    ApiService.pdfFile("pdf/production-peeling/?productionPeeling_id=" + ids).then((data) =>
      res(data)
    );
  });
};
const productionPeelingObjClone = function () {
  return {
    id: 0,
    qty: "",
    reQty: "",
    waste: "",
    status: "",
    dateIn: new Date(),
    dateOut: new Date(),
    remark: "",
    production_id: "",
    production_data: {},
    design_material_item_id: "",
    design_material_item_data: {},
    created_by: "",
  };
};
const jsonToInterface = function (item: any) {
  const newItem: ProductionPeeling = productionPeelingObjClone();
  newItem.id = item.id;
  newItem.qty = item.qty;
  newItem.reQty = item.reQty;
  newItem.waste = item.waste;
  newItem.status = item.status;
  newItem.dateOut = moment(item.dateOut).toDate();
  newItem.dateIn = moment(item.dateIn).toDate();
  newItem.remark = item.remark;
  newItem.production_id = item.production_id;
  newItem.production_data = item.production_data;
  newItem.design_material_item_id = item.design_material_item_id;
  newItem.design_material_item_data = item.design_material_item_data;
  newItem.created_by = item.created_by;
  return newItem;
};
const getProductionPeelingById = function (id) {
  return new Promise((res, rej) => {
    ApiService.get(`production-peeling/${id}`).then(function (response) {
      res(jsonToInterface(response.data));
    });
  });
};

const getProductionPeelings = function (
  pageNumber = 1,
  searchData,
  status = "",
  production_id = "",
  design_material_item_id = ""
) {
  return new Promise((res, rej) => {
    const limit = 10;
    const queryObj = {
      page: pageNumber,
      limit: limit,
      offset: (pageNumber - 1) * limit,
      search: searchData.name || "",
      status: status,
      production_id: production_id,
      design_material_item_id: design_material_item_id,
    };
    console.log(queryObj);
    const queryStr = Object.keys(queryObj)
      .filter((key) => queryObj[key] != "")
      .map((key) => key + "=" + queryObj[key])
      .join("&");

    if (typeof cancelRequest != typeof undefined) {
      cancelRequest.cancel("Operation canceled due to new request.");
    }
    cancelRequest = CancelToken.source();
    ApiService.getWithoutSlash(`production-peeling/?${queryStr}`, cancelRequest)
      .then(function (response) {
        const resObj: any = {
          count: 0,
          data: [],
        };
        resObj.count = response.data.count;
        if (response.data && response.data.results) {
          resObj.data = response.data.results.map((item) => {
            return jsonToInterface(item);
          });
        }
        console.log("resObj", resObj);
        res(resObj);
      })
      .catch((error) => rej(error));
  });
};

const jsonToInterfaceProductionPeeling = jsonToInterface;
const getEmptyObjOfProductionPeeling = productionPeelingObjClone;
export {
  ProductionPeeling,
  getProductionPeelings,
  deleteProductionPeeling,
  addProductionPeeling,
  getProductionPeelingById,
  jsonToInterfaceProductionPeeling,
  productionPeelingObjClone,
  exportProductionPeelingData,
  exportPDFProductionPeelings,
  getEmptyObjOfProductionPeeling,
};

export default ProductionPeelings;
